// 群成员列表滚动条项高度
export const GROUP_MEMBER_SCROLLER_ITEM_SIZE = {
  role: 30,
  member: 50,
  split: 11,
};

// 群成员列表请求限制
export const GROUP_CHAT_MEMBER_REQUEST_LIMIT = 100;

// 群成员角色
export enum GROUP_CHAT_MEMBER_ROLE {
  owner = 99,
  admin = 1,
  member = 0,
}

// 群聊全体成员
export const GROUP_CHAT_ALL_MEMBER = -9999;

// 群聊@类型
export const GROUP_CHAT_AT_TYPES = {
  ALL: 'all',
};

/**
 * 群聊权限 key 名称
 */
export enum CHAT_GROUP_PERMISSION_KEY_NAMES {
  removeMember = 'removeMember', // 移除成员
  dismissGroup = 'dismissGroup', // 解散群聊
  editInfo = 'editInfo', // 编辑群信息
  manageBlacklist = 'manageBlacklist', // 管理黑名单
  manageManager = 'manageManager', // 管理管理员
  withdrawMessage = 'withdrawMessage', //撤回消息
  manageVerify = 'manageVerify', // 管理进群申请
}

/**
 * 群聊权限 对应二进制位
 */
export const CHAT_GROUP_PERMISSION: Record<
  CHAT_GROUP_PERMISSION_KEY_NAMES,
  number
> = {
  [CHAT_GROUP_PERMISSION_KEY_NAMES.removeMember]: 1 << 0,
  [CHAT_GROUP_PERMISSION_KEY_NAMES.dismissGroup]: 1 << 1,
  [CHAT_GROUP_PERMISSION_KEY_NAMES.editInfo]: 1 << 2,
  [CHAT_GROUP_PERMISSION_KEY_NAMES.manageBlacklist]: 1 << 3,
  [CHAT_GROUP_PERMISSION_KEY_NAMES.manageManager]: 1 << 4,
  [CHAT_GROUP_PERMISSION_KEY_NAMES.withdrawMessage]: 1 << 5,
  [CHAT_GROUP_PERMISSION_KEY_NAMES.manageVerify]: 1 << 6,
};

// 群聊角色权限映射
export const GROUP_CHAT_ROLE_PERMISSIONS_MAP: Record<
  GROUP_CHAT_MEMBER_ROLE,
  number
> = {
  [GROUP_CHAT_MEMBER_ROLE.owner]:
    CHAT_GROUP_PERMISSION.removeMember |
    CHAT_GROUP_PERMISSION.dismissGroup |
    CHAT_GROUP_PERMISSION.editInfo |
    CHAT_GROUP_PERMISSION.manageBlacklist |
    CHAT_GROUP_PERMISSION.manageManager |
    CHAT_GROUP_PERMISSION.withdrawMessage |
    CHAT_GROUP_PERMISSION.manageVerify,
  [GROUP_CHAT_MEMBER_ROLE.admin]:
    CHAT_GROUP_PERMISSION.removeMember |
    CHAT_GROUP_PERMISSION.editInfo |
    CHAT_GROUP_PERMISSION.manageBlacklist |
    CHAT_GROUP_PERMISSION.withdrawMessage |
    CHAT_GROUP_PERMISSION.manageVerify,
  [GROUP_CHAT_MEMBER_ROLE.member]: 0,
};

// 群聊成员变化操作
export enum GROUP_CHAT_MEMBER_CHANGE_OPERATIONS {
  add = 1,
  remove = 2,
}

// 群聊默认头像
export const GROUP_CHAT_DEFAULT_AVATAR =
  'https://imgheybox.max-c.com/oa/2025/09/04/7b947ceaab896f7008e28a1b145efbed.png';

/**
 * 进群条件
 */
export enum GROUP_CHAT_ENTER_CONDITIONS {
  /**
   * 无条件
   */
  none = 0,
  /**
   * 关注群主
   */
  follow_group_owner = 1,
  /**
   * 关注群主7天
   */
  follow_group_owner_7 = 2,
  /**
   * 关注群主30天
   */
  follow_group_owner_30 = 3,
}

/**
 * 默认群聊加入条件选项
 */
export const DEFAULT_GROUP_CHAT_JOIN_SETTINGS = [
  {
    join_condition_id: 0,
    text: '无条件',
  },
  {
    join_condition_id: 1,
    text: '关注群主',
  },
  {
    join_condition_id: 2,
    text: '关注群主7天以上',
  },
  {
    join_condition_id: 3,
    text: '关注群主30天以上',
  },
];

/**
 * 进群申请状态
 */
export enum GROUP_PENDING_APPROVAL_ITEM_STATES {
  /**
   * 同意
   */
  approved = 1,
  /**
   * 拒绝
   */
  rejected,
}
